// extracted by mini-css-extract-plugin
module.exports = {"bottombarWrapper":"Bottombar_bottombarWrapper__qYjl4","bottombarLink":"Bottombar_bottombarLink__1suSU","notificationIcon":"Bottombar_notificationIcon__133Qx"};